"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateProgress;

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _calculateProgress = _interopRequireDefault(require("./calculateProgress"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

function updateProgress(_ref) {
  var event = _ref.event,
      progressBar = _ref.progressBar,
      step = _ref.step,
      start = _ref.start,
      end = _ref.end,
      roundingAccuracy = _ref.roundingAccuracy,
      onChange = _ref.onChange,
      input = _ref.input;
  var progressOffset = (0, _documentOffset["default"])(progressBar);

  if (progressOffset) {
    var value = (0, _calculateProgress["default"])({
      offset: progressOffset,
      offsetWidth: progressBar.offsetWidth,
      pageX: event.touches ? event.touches[0] && event.touches[0].pageX : event.pageX,
      step: step,
      start: start,
      end: end,
      roundingAccuracy: roundingAccuracy
    });

    if (typeof onChange === 'function' && input) {
      input.value = value;
      onChange((0, _syntheticEvent["default"])(input));
    }
  }
}

;